module.exports = __webpack_public_path__ + "static/media/backpackgirl.53555484.gif";